import { CloseOutlined, MinusSquareOutlined } from '@ant-design/icons';
import { Checkbox, Typography } from 'antd';
import './csvTool.scss';

const AliasCard = ({ handleRemoveColumn, column, handleRemoveName, currentIndex }) => {
    return (
        <div className="outer_box">
            <div className="box_head">
                <CloseOutlined className="pointer delete_icon" onClick={() => handleRemoveColumn(currentIndex)} />
                <Typography.Text className="alias_head">{column.columnName}</Typography.Text>
            </div>
            <div className="name_container">
                {column?.dependency?.map((item, i) => (
                    <div key={i} className="name_box">
                        <MinusSquareOutlined className="remove_icon pointer" onClick={() => handleRemoveName(currentIndex, i)} />
                        <Typography.Text style={{ textAlign: 'start' }}>{item}</Typography.Text>
                    </div>
                ))}
            </div>
        </div>
    );
};
export default AliasCard;
